import React, { FC, memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import useStyles from './style';

const OverlayGradient: FC = () => {
  const classes = useStyles();

  const [target, setTarget] = useState<Nullable<Element>>(null);

  useEffect(() => {
    setTarget(document.querySelector('.eventLayoutContainer'));
  }, []);

  return !!target && createPortal(<span className={classes.overlayGradient}></span>, target);
};

export default memo(OverlayGradient);
